module.exports = __webpack_public_path__ + "media/images/ui__lockLocked--dark-5f15e6ecd5e3e94d67e0451a87eabc48.png";